<template>
    <div class="articles fade21"
        :class="{'active': $parent.isfadeInActive && $parent.isfadeInA7,
        'bg1':targetIdx===0,
        'bg2':targetIdx===1,
        'bg3':targetIdx===2}">
        <div :id="`carousel${targetIdx}`" class="articles-wrapper"
        v-if="data && data.length">
            <article class="article-wrapper article7"
            v-for="(n, idx) in data" :key="idx">
                <a :href="n.link" class="mg-1"
                target="_blank">
                    <div class="photo-wrapper">
                        <img :src="n.image_path"
                        class="photo"
                        v-if="n.image_path" />
                        <img src="@/assets/images/article7/img_photo_default@3x.png"
                        class="photo"
                        v-else />
                    </div>
                    <div class="text-wrapper">
                        <h2 class="title" v-text="n.title">《返校Detention》實境體驗展簡介</h2>
                        <div class="info-wrapper">
                            <p class="source">
                                【發布單位／{{n.title_unit}}】
                            </p>
                        </div>
                        <p class="description" v-html="n.content + (n.link ? n.link : '')">
                            內容還原自赤燭團隊於2017年1月上市，引起轟動的暢銷恐怖電腦遊戲─《返校Detention》，
                            更是首次挑戰將電腦單機遊戲轉換成實境體驗性質的多元展覽。欲了解更多展出資訊請點選連結：www.xxxxx.tw
                        </p>
                    </div>
                </a>
            </article>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'news7',
    props: {
        data: {
            type: Array,
            default() {
                return [{
                    title: '',
                    title_unit: '',
                    content: '',
                    link: '',
                    image_path: '',
                }];
            },
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            gaCategory: '',
        };
    },
    mounted() {
    },
    methods: {
        initSlick() {
            window.setTimeout(() => {
                $(`#carousel${this.targetIdx}`).slick({
                    slidesToShow: 3,
                    autoplay: false,
                    speed: 1000,
                    arrows: true,
                    dots: false,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                                dots: false,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                dots: true,
                            },
                        },
                    ],
                });
            }, 500);
        },
    },
    created() {
        this.initSlick();
    },
    watch: {
        data: {
            handler(val) {
                if (val && val.length) {
                    this.initSlick();
                }
            },
            deep: true,
        },
    },
    mixins: [mixinMethod],
};
</script>
